import { Loadable } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { Card } from '@/lib/Layout/Card';
import { TranslationKeys } from '@/localization';
import { ComponentProps, FC, ReactNode } from 'react';
import { HomeDataSectionAction, HomeDataSectionHeader, HomeDataSectionTotal } from './parts';

type HomeDataSectionProps = {
  totalLabel: TranslationKeys;
  totalValue: number;
  chart: ReactNode;
  createPath: (typeof RouteConstants)[keyof typeof RouteConstants];
  creteButtonText: TranslationKeys;
  isLoading?: boolean;
  showButtonIcon?: boolean;
} & ComponentProps<typeof HomeDataSectionHeader>;

export const HomeDataSection: FC<HomeDataSectionProps> = ({
  icon,
  title,
  totalLabel,
  totalValue,
  chart,
  createPath,
  creteButtonText,
  showButtonIcon,
  isLoading,
}) => {
  return (
    <>
      <HomeDataSectionHeader icon={icon} title={title} className='col-span-full pt-2.5 first:p-0' />
      <Card className='col-span-full grid grid-cols-subgrid place-items-center gap-5'>
        <Loadable isLoading={isLoading} className='col-span-full min-h-64'>
          <div className='col-span-full flex w-full justify-between @5xl/page:col-span-1'>
            <HomeDataSectionTotal label={totalLabel} value={totalValue} />
            <HomeDataSectionAction
              path={createPath}
              text={creteButtonText}
              showButtonIcon={showButtonIcon}
              className='justify-self-end px-2 @5xl/page:hidden'
            />
          </div>
          {chart}
          <HomeDataSectionAction path={createPath} text={creteButtonText} showButtonIcon={showButtonIcon} className='hidden @5xl/page:block' />
        </Loadable>
      </Card>
    </>
  );
};
